import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RespondentTokenStorageService } from '@core/services/respondent-token-storage.service';

export const respondentAuthGuard: CanActivateFn = () => {
  const tokenStorage = inject(RespondentTokenStorageService);
  const router = inject(Router);

  if (tokenStorage.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/my-forms']);
};
